import { render, staticRenderFns } from "./GamesList.vue?vue&type=template&id=362aedf8&lang=pug"
import script from "./GamesList.vue?vue&type=script&lang=js"
export * from "./GamesList.vue?vue&type=script&lang=js"
import style0 from "./GamesList.vue?vue&type=style&index=0&id=362aedf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports